import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { DialogContent, DialogContentText } from "@material-ui/core";
import BankAccountAddForm from "../BankAccount/Add/BankAccountAddForm";

const BankAccountAddModal = (props) => {
  const { handleClose } = props;

  return (
    <Wrapper>
      <DialogContent>
        <DialogContentText>
          <BankAccountAddForm isModal={true} handleClose={handleClose} />
        </DialogContentText>
      </DialogContent>
    </Wrapper>
  );
};

export default BankAccountAddModal;
